/** State for the Organizations registry feature. */
export type State = Record<string, never>

export namespace State {
  /** Initial registry state. Dynamic collections live in the EC instance registry. */
  export const INITIAL: State = {}
}
